import * as Yup from "yup";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { Field, Form, Formik, FormikHelpers } from "formik";

import BaseInput from "../../../../../components/elements/BaseInput";
import Button from "../../../../../components/elements/Button";
import FormFieldError from "../../../../../components/elements/FormFieldError";
import classes from "./Controls.module.scss";

type UtlParamsModalProps = {
  selectedLandingPage: string;
  isOpen: boolean;
  handleClose: () => void;
  handleSave: (url: string) => void;
};

type FormInitialValues = {
  campaign: string;
  content: string;
  medium: string;
  source: string;
  term: string;
};

const UtmParamsModal: FC<UtlParamsModalProps> = ({ selectedLandingPage, isOpen, handleClose, handleSave }) => {
  const formInitialValues: FormInitialValues = {
    campaign: "",
    content: "",
    medium: "",
    source: "",
    term: "",
  };

  const validationSchema = Yup.object({
    campaign: Yup.string().required("Required field."),
    content: Yup.string().required("Required field."),
    medium: Yup.string().required("Required field."),
  });

  const handleSubmit = async (values: FormInitialValues, actions: FormikHelpers<FormInitialValues>) => {
    const { campaign, content, medium, source, term } = values;
    const baseUrl = selectedLandingPage.split("?")[0];
    let utmUrl = `${baseUrl}?utm_campaign=${encodeURIComponent(campaign.trim())}&utm_content=${encodeURIComponent(
      content.trim(),
    )}&utm_medium=${encodeURIComponent(medium.trim())}`;

    if (source) {
      utmUrl += `&utm_source=${encodeURIComponent(source.trim())}`;
    }

    if (term) {
      utmUrl += `&utm_term=${encodeURIComponent(term.trim())}`;
    }
    handleSave(utmUrl);
    actions.resetForm();
    handleClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="Enter Custom Url Modal"
      className={classes.modalContainer}
    >
      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnBlur={false}
      >
        {({ values }) => (
          <>
            <div className={classes.dialogTitle}>
              <Typography variant="h2">UTM URL Creator</Typography>
            </div>

            <Form>
              <DialogContent className={classes.dialogContent}>
                <div className={classes.input}>
                  <Field as={BaseInput} value={values.campaign} name="campaign" variant="outlined" label="Campaign *" />

                  <FormFieldError name="campaign" />
                </div>

                <div className={classes.input}>
                  <Field as={BaseInput} value={values.content} name="content" variant="outlined" label="Content *" />

                  <FormFieldError name="content" />
                </div>

                <div className={classes.input}>
                  <Field as={BaseInput} value={values.medium} name="medium" variant="outlined" label="Medium *" />

                  <FormFieldError name="medium" />
                </div>

                <div className={classes.input}>
                  <Field as={BaseInput} value={values.source} name="source" variant="outlined" label="Source" />

                  <FormFieldError name="source" />
                </div>

                <div className={classes.input}>
                  <Field as={BaseInput} value={values.term} name="term" variant="outlined" label="Term" />

                  <FormFieldError name="term" />
                </div>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} variant="outlined">
                  Cancel
                </Button>
                <Button type="submit">Save Custom URL</Button>
              </DialogActions>
            </Form>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default UtmParamsModal;
